import { render, staticRenderFns } from "./CustomerContactDetails.vue?vue&type=template&id=838d6cc6&scoped=true&"
import script from "./CustomerContactDetails.vue?vue&type=script&lang=ts&"
export * from "./CustomerContactDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerContactDetails.vue?vue&type=style&index=0&id=838d6cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838d6cc6",
  null
  
)

export default component.exports